import "./UploadAttachment.css";
import React from "react";
import ProgressBar from "@ramonak/react-progress-bar";

const UploadAttachment = ({ selectedFile, attachmetTitle, progress }) => {
  const getAttachmentIcon = (type) => {
    if (!type) return null;

    if (
      type.match(/image\/(jpeg|png|gif|bmp)/i) ||
      type.match(/(jpg|jpeg|png|gif|bmp)/i)
    ) {
      return <i className="fas fa-file-image attachment-icon"></i>;
    } else if (
      type.match(/video\/(mp4|avi|mov|webm)/i) ||
      type.match(/(mp4|avi|mov|webm)/i)
    ) {
      return <i className="fas fa-file-video attachment-icon"></i>;
    } else if (
      type.match(
        /application\/(msword|vnd.openxmlformats-officedocument.wordprocessingml.document)/i
      ) ||
      type.match(/(doc|docx)/i)
    ) {
      return <i className="fas fa-file-word attachment-icon"></i>;
    } else if (
      type.match(
        /application\/(vnd.ms-excel|vnd.openxmlformats-officedocument.spreadsheetml.sheet)/i
      ) ||
      type.match(/(xls|xlsx|sheet)/i)
    ) {
      return <i className="fas fa-file-excel attachment-icon"></i>;
    } else if (
      type.match(
        /application\/(vnd.ms-powerpoint|vnd.openxmlformats-officedocument.presentationml.presentation)/i
      ) ||
      type.match(/(ppt|pptx)/i)
    ) {
      return <i className="fas fa-file-powerpoint attachment-icon"></i>;
    } else if (type.match(/application\/pdf/i) || type.match(/pdf/i)) {
      return <i className="fas fa-file-pdf attachment-icon"></i>;
    } else if (type.match(/audio\/mp3/i) || type.match(/mp3/i)) {
      return <i className="fas fa-file-audio attachment-icon"></i>;
    } else {
      return <i className="fas fa-link attachment-icon"></i>;
    }
  };
  return (
    <span className="d-flex flex-column justify-content-start align-items-left adding-new-attachment">
      <div className="upload-attachment-icon-box">
        <div className="d-flex flex-column justify-content-center align-items-center  wrapper">
          {selectedFile && getAttachmentIcon(selectedFile.type)}
        </div>
      </div>
      <div className="attachment-titile">{attachmetTitle}</div>
      <div className="px-2 mb-2 mt-1">
        <div className="uploaded-progress">
          <ProgressBar
            completed={Math.round(progress)}
            height="10px"
            isLabelVisible={false}
            bgColor="#4e10ff"
          />
        </div>
      </div>
    </span>
  );
};

export default UploadAttachment;
